import React, { useMemo } from "react";

import { IFilter } from "../../../context/filters";
import { ISelectedFilterMap, useSelectedFilters } from "../../../context/selectedFilters";
import { BaseFilter, getFilterGroups, IEntityFilterItem } from "../BaseFilter";
import { FilterLink } from "./FilterLink";
import { TravelFilterLink } from "./TravelFilterLink";
import {
  getFilterLinkProps,
  getTravelCompanyLinkProps,
  isTravelInsuranceCompanyFilter
} from "./helpers/filterLinkProps";
import { useFilterItemOptions } from "./hooks";
import { useAppContext } from "../../../../../lib/appContext";
import { isTravel } from "../../../helpers/isTravel";

const getFilterItem = (
  basePath: string,
  selectedFilterMap: ISelectedFilterMap,
  businessUnitCode: string,
  businessUnitSlug: string,
  countryCode: string
) => (entityFilter: IEntityFilterItem, filter: IFilter) => (title: string) => {
  if (isTravel(businessUnitCode) && isTravelInsuranceCompanyFilter(countryCode, entityFilter)) {
    const props = getTravelCompanyLinkProps(countryCode, businessUnitSlug, filter, title);
    return <TravelFilterLink {...props} />;
  }

  const props = getFilterLinkProps(basePath, selectedFilterMap, entityFilter, filter, title);
  return <FilterLink {...props} />;
};

export const ProductFilters: React.FC = () => {
  const {
    businessUnitSlug,
    businessUnitConfig: { businessCode },
    countryCode
  } = useAppContext();
  const path = `/${businessUnitSlug}`;
  const selectedFilterMap = useSelectedFilters();
  const { filters, loading } = useFilterItemOptions();
  const groupedFilters = useMemo(
    () =>
      getFilterGroups(
        filters,
        getFilterItem(path, selectedFilterMap, businessCode, businessUnitSlug, countryCode)
      ),
    [filters, selectedFilterMap]
  );

  return <BaseFilter filterGroups={groupedFilters} loading={loading} />;
};
